import {
    useEffect,
    useState,
} from 'react'

const DEFAULT_DELAY_TO_SHOW = 300

const useDelayedLoading = ({
    loadingTriggered,
    delayToShow = DEFAULT_DELAY_TO_SHOW,
}: Readonly<{
    loadingTriggered: boolean,
    delayToShow?: number,
}>) => {
    const [
        showLoading,
        setShowLoading,
    ] = useState(false)

    useEffect(() => {
        let timeoutId = null

        if (loadingTriggered) {
            timeoutId = setTimeout(() => {
                setShowLoading(true)
            }, delayToShow)
        } else {
            setShowLoading(false)
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        }
    }, [
        delayToShow,
        loadingTriggered,
    ])

    return showLoading
}

export default useDelayedLoading
